import { ICdpUserIdentity } from './types';

export const createIdentity = (
  email: string,
  customerid: string,
  ccToken: string
): ICdpUserIdentity => {
  return { email, customerid, other3: ccToken };
};
